

















































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Video from "@/components/Video.vue";
import Pdf from "@/components/Pdf.vue";
import { BIcon, BIconBoxArrowRight, BIconUpload } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    Menu,
    Video,
    Pdf,
    BIcon,
    BIconBoxArrowRight,
    BIconUpload,
    NextPrevBtn,
    Footer,
  },
})
export default class ProjectionTips extends Vue {
  protected pdfSlideTips = [
    {
      PdfLink: "/pdf_projection/HelpPP.pdf",
      PdfDownload: "GuidePowerPoint",
      TxtPdf: "Guide PowerPoint",
    },
  ];
  protected nxtprevProjectionTips = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail5.png",
    NextImage: "/thumbnail7.png",
    PrevLink: "/Diaporama/Fondamentaux",
    NextLink: "/Diaporama/EnPratique",
  };
}
